import { useEffect, useLayoutEffect } from 'react';

/**
 * `useLayoutEffect` on the client, `useEffect` during prerender (where React
 * warns because layout effects can't run on the server). Both hooks are no-ops
 * on the server, so falling back to `useEffect` is safe — the layout-effect
 * timing only matters once the bundle is running in a browser.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
